/**
 * Converts a string to a URL-friendly slug (kebab-case).
 * 
 * Rules:
 * - Convert to lowercase
 * - Replace spaces and punctuation with hyphens
 * - Remove consecutive hyphens
 * - Trim hyphens from the beginning and end
 * 
 * @param text - The text to convert to a slug
 * @returns The slugified string
 * 
 * @example
 * slugify('Hello World!') // 'hello-world'
 * slugify('  Test   String  ') // 'test-string'
 * slugify('Multiple---Hyphens') // 'multiple-hyphens'
 */
export function slugify(text: string): string {
    if (!text) {
        return '';
    }

    return text
        .toLowerCase()
        .trim()
        // Replace spaces and common punctuation with hyphens
        .replace(/[\s_]+/g, '-')
        // Replace other punctuation (except alphanumeric and hyphens) with hyphens
        .replace(/[^\w-]+/g, '-')
        // Replace multiple consecutive hyphens with a single hyphen
        .replace(/-+/g, '-')
        // Remove hyphens from the beginning and end
        .replace(/^-+|-+$/g, '');
}

